import { render, staticRenderFns } from "./AsyncResource.vue?vue&type=template&id=31f4de74&scoped=true&"
import script from "./AsyncResource.vue?vue&type=script&lang=js&"
export * from "./AsyncResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4de74",
  null
  
)

export default component.exports